[
    {
        "auth": true,
        "userType": "client",
        "links": [
            {
                "code": "dashboard",
                "value": "/dashboard"
            }
        ],
        "menu": [
            { "code": "documents", "value": "/documents" },
            { "code": "settings", "value": "/settings" },
            { "code": "logout", "value": "/logout" }
        ],
        "intercom": false
    },
    {
        "auth": true,
        "userType": "broker",
        "links": [
            {
                "code": "policies",
                "value": "/policies",
                "label": "Policies"
            },
            {
                "code": "leads",
                "value": "/leads"
            }
        ],
        "menu": [
            {
                "code": "settings",
                "value": "/settings"
            },
            {
                "code": "logout",
                "value": "/logout"
            }
        ],
        "intercom": false
    },
    {
        "auth": true,
        "userType": "administrator",
        "links": [
            {
                "code": "policies",
                "value": "/policies",
                "label": "Policies"
            },
            {
                "code": "clients",
                "value": "/search"
            },
            {
                "code": "leads",
                "value": "/leads"
            }
        ],
        "menu": [
            {
                "code": "settings",
                "value": "/settings"
            },
            {
                "code": "logout",
                "value": "/logout"
            }
        ],
        "intercom": false
    }
]
